import type React from "react";
import classes from "./MetricDashboard.module.css";
import Plot from "react-plotly.js";
import { useEffect, useState } from "react";
import { chart_courseComplete } from "../../connections";
import { msToTime } from "../../utils/time";
import ClockIcon from "./ClockIcon";
interface LearnerData {
  complete_number: string;
  complete_percentage: string;
  in_progress_number: string;
  in_progress_percentage: string;
  average_completion_time: number;
}

type ApiResponse = { data: LearnerData[] };
const MetricsDashboard: React.FC = () => {
  const [completedData, setCompletedData] = useState<Partial<Plotly.PlotData>>(
    {}
  );

  const [inProgressData, setInProgressData] = useState<
    Partial<Plotly.PlotData>
  >({});
  const [averageTime, setAverageTime] = useState<string>("00:00:00");
  const [completed, setCompleted] = useState<string>("0");
  const [inProgress, setInprogress] = useState<string>("0");

  useEffect(() => {
    const getChartData = async () => {
      const data: ApiResponse = await chart_courseComplete();
      setAverageTime(msToTime(data.data[0].average_completion_time));
      console.log("StudentGraph data", data);
      const inProgressCount = Number(data.data[0].in_progress_number || 0);
      const completedCount = Number(data.data[0].complete_number || 0);
      setCompleted(completedCount.toString());
      setInprogress(inProgressCount.toString());

      setCompletedData({
        x: [data.data[0].complete_percentage],
        y: [""],
        type: "bar" as const,
        orientation: "h" as const,
        name: "Completed",
        marker: {
          color: "#26BCD7",
        },
        hoverinfo: "skip" as const,
        showlegend: false,
      });
      setInProgressData({
        x: [data.data[0].in_progress_percentage],
        y: [""],
        type: "bar" as const,
        orientation: "h" as const,
        name: "In Progress",
        marker: {
          color: "#006E87",
        },
        hoverinfo: "none" as const,
        showlegend: false,
      });
    };
    getChartData();
  }, []);
  
  const layout = {
    height: 43,
    margin: {
      l: 0,
      r: 0,
      t: 0,
      b: 0,
    },
    xaxis: {
      range: [0, 100],
      showgrid: false,
      zeroline: false,
      showticklabels: false,
    },
    yaxis: {
      showgrid: false,
      zeroline: false,
      showticklabels: false,
    },
    bargap: 0,
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "#F2F2F6",
    barcornerradius: 5,
    annotations: [
      {
        x: 95,
        y: 0,
        text: "",
        showarrow: false,
      },
    ],
  };
  
  const layoutInProgress = {
    ...layout,
    annotations: [
      {
        x: 95,
        y: 0,
        text: "",
        showarrow: false,
        font: {
          size: 14,
          color: "#4b5563",
        },
      },
    ],
  };
  
  const config = {
    displayModeBar: false,
    responsive: true,
    staticPlot: true,
  };

  return (
    completedData &&
    inProgressData && (
      <div className={classes.metricsContainer}>
        <h2 className={classes.metricsTitle}>
          How many learners have completed the course?
        </h2>

        <div className={classes.metricsContent}>
          <div className={classes.metricsContentLeft}>
            <div className={classes.metricsRow}>
              <div className={classes.metricsLeft}>
                <div className={classes.metricNumber}>{completed || "0"}</div>
                <div className={classes.metricLabel1}>
                  Total Learners Complete
                </div>
              </div>
              <div className={classes.verticalLine}></div>
              <div className={classes.metricsRight}>
                <Plot
                  data={[completedData]}
                  layout={layout}
                  config={config}
                  className={classes.plotlyChart}
                />
                <div className={classes.metricLabel2}>
                  {completedData.x?.[0]?.toString() || "0"}%
                </div>
              </div>
            </div>

            <div className={classes.metricsRow}>
              <div className={classes.metricsLeft}>
                <div className={classes.metricNumber}>{inProgress || "0"}</div>
                <div className={classes.metricLabel}>
                  Total Learners In Progress
                </div>
              </div>
              <div className={classes.verticalLine}></div>
              <div className={classes.metricsRight}>
                <Plot
                  data={[inProgressData]}
                  layout={layoutInProgress}
                  config={config}
                  className={classes.plotlyChart}
                />
                <div className={classes.metricLabel2}>
                  {inProgressData.x?.[0]?.toString() || "0"}%
                </div>
              </div>
            </div>
          </div>

          {averageTime && (
            <div className={classes.completionTimeBox}>
              <div className={classes.completionTimeTitle}>
                Average Time to Completion
              </div>
              <div className={classes.completionTimeContent}>
                <div className={classes.timerIcon}>
                  <ClockIcon/>
                </div>
                <div className={classes.completionTimeDetails}>
                  <div className={classes.completionTimeLabel}>
                    Entire Courses
                  </div>
                  <div className={classes.completionTimeValue}>
                    {averageTime}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default MetricsDashboard;
